import { ValidationError } from "../../../../shared/Models/ValidationError";

const buildingCharacteristicEmpty = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.buildingCharacteristicEmpty: Please pick a building characteristic.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);
const studentHomeAtleastOneUnit = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.studentHomeUnitGreaterThanZero: A student home needs at least 1 Unit.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const studentHomeAtleastOneBU = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.studentHomeBUGreaterThanZero: A student home needs at least 1 Bussines Unit.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const studentHomeCountNotEqual = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.studentHomCountNotEqual: Building Student Home and Address student home don't add up.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const studentHomeAtleastOneStudentHome = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.studentHomeGreaterThanZero: A student home needs at least 1 Student Home.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const notInUse0Units = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.notInUseZeroOrOne: A NotInUse Building Type needs 0 Unit.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const noAccesAtleastTwoUnits = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.noAccessAtleastTwo: A NoAccess Building Type needs at least 2 Units.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const emptyParcelAtleastOneUnit = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.emptyParcelMoreThanOne: An Empty Parcel needs at least 1 Unit.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const inUseAtleastOneUnit = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.inUseMoreThanOneUnit: An In Use Building Type needs at least 1 Unit.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const inUseAtleastOneMultipleUnits = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.inUseAtleastOneMultipleUnits: At least one of the addresses needs an InUseMultipleUnits Address Type.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const inUseMultipleBuildingType = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.inUseMultipleBuildingType: One of the buildings has an unexisiting Building Type value.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const inUseWithoutBuildingUnit = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.inUseWithoutBuildingUnitType: Building type InUseWithoutBuildingUnits can't have any units.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

const inUseZeroUnitsAddressAtLeastOne = new ValidationError(
  $localize`:@@general.warning: Warning`,
  $localize`:@@validation.survey.inUseZeroUnitsAddressAtLeastOne: Building type InUseWithoutBuildingUnits must have at least one InUseZeroUnits Address.`,
  $localize`:@@survey.inside.outside.units.title: Outside Units`
);

export const buildingTypeMessages = {
  buildingCharacteristicEmpty,
  studentHomeAtleastOneUnit,
  studentHomeAtleastOneBU,
  studentHomeAtleastOneStudentHome,
  studentHomeCountNotEqual,
  noAccesAtleastTwoUnits,
  notInUse0Units,
  emptyParcelAtleastOneUnit,
  inUseAtleastOneUnit,
  inUseAtleastOneMultipleUnits,
  inUseMultipleBuildingType,
  inUseWithoutBuildingUnit,
  inUseZeroUnitsAddressAtLeastOne,
};
